import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { paymentMethodUpdate } from '../../../redux/actions/paymentMethods';

const EditPaymentMethodModal = ({ payload, showEditPaymentMethodModal, setShowEditPaymentMethodModal, paymentMethod, editPaymentMethod }) => {
  const [methodName, setMethodName] = useState(null);

  const paymentMethodJson = () => {
    return {
      method_name: (methodName || paymentMethod.method_name)
    }
  }

  const changeName = (event) => {
    let value = event.target.value;
    setMethodName(value);
  }

  const update = () => {
    editPaymentMethod(payload, paymentMethod.id, paymentMethodJson());
    setShowEditPaymentMethodModal(false);
  }

  return(
    <>
      { paymentMethod &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowEditPaymentMethodModal(false),
            },
            { text: 'Update Payment Method', onClick: () => update() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Update Payment Method"
          isOpen={showEditPaymentMethodModal}
          onClose={() => setShowEditPaymentMethodModal(false)}
        >
          <H3>Update {paymentMethod.method_name}</H3>
          <Input
            description={`Current value: ${paymentMethod.method_name}`}
            label="Payment Method Name"
            onChange={changeName}
            placeholder="Payment Method Name"
            type="text"
            value={methodName}
            required
          />
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  editPaymentMethod: (payload, paymentMethodId, paymentMethod) => dispatch(paymentMethodUpdate(payload, paymentMethodId, paymentMethod)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPaymentMethodModal);